// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6db55d52","498":"6bca8ccc","513":"889a6d68","787":"909fdc84"}[chunkId] + ".chunk.js";
};